import React from "react";

export class TextCenter extends React.Component<React.PropsWithChildren<{}>> {
    public render (): JSX.Element {
        return (
            <span className="text-center">{this.props.children}</span>
        );
    }
}
